import React, { FC } from "react";
import TabFilters from "./TabFilters";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import BookCard from "components/BookCard/BookCard";
import { bookingType } from "data/types";

export interface SectionGridFilterCardProps {
  className?: string;
  data: bookingType[];
}



const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "", 
  data = []
}) => {

  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
    >
      <div className="mb-8 lg:mb-11">
        <TabFilters />
      </div>
      <div className="lg:p-10 lg:bg-neutral-50 lg:dark:bg-black/20 grid grid-cols-1 gap-6  rounded-3xl">
        {data.map((item, index) => (
          <BookCard key={index} data={item} />
        ))}

        <div className="flex mt-12 justify-center items-center">
          <ButtonPrimary loading>Show more</ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default SectionGridFilterCard;
